import { useState } from "react";
import PrintIcon from "@mui/icons-material/Print";
import PrintDisabledIcon from "@mui/icons-material/PrintDisabled";
import { useDataProvider, useRecordContext } from "react-admin";
import Button from "@mui/material/Button";

import resources from "../../constants/resources";
import { PUBLISH_LABEL, UNPUBLISH_LABEL } from "../../constants/titleConstants";

const ContentPublicationButton = () => {
  const record = useRecordContext();
  const [updatedPublished, setUpdatedPublished] = useState(undefined);
  const isPublished =
    updatedPublished !== undefined ? updatedPublished : record.is_published;
  const dataProvider = useDataProvider();

  const handleContentPublication = () => {
    setUpdatedPublished(!isPublished);
    dataProvider.create(resources.CONTENTS_PUBLICATION.url, {
      data: { id: record.id, is_published: !isPublished },
    });
  };

  return (
    <Button
      variant="contained"
      onClick={handleContentPublication}
      title={isPublished ? UNPUBLISH_LABEL : PUBLISH_LABEL}
      startIcon={isPublished ? <PrintDisabledIcon /> : <PrintIcon />}
    >
      {isPublished ? UNPUBLISH_LABEL : PUBLISH_LABEL}
    </Button>
  );
};

export default ContentPublicationButton;
